<div class="header-notification">
    <button
        type="button"
        class="notification-bell"
        (click)="togglePanel($event)"
        [attr.aria-expanded]="panelOpen"
        [attr.aria-label]="'header.notifications.ariaBell' | translate"
    >
        <img src="assets/icons/icon-notification.svg" alt="" class="bell-icon" />
        <span class="badge" *ngIf="unreadBadge > 0">{{ unreadBadge > 99 ? '99+' : unreadBadge }}</span>
    </button>

    <ng-container *ngIf="panelOpen">
        <div
            class="notification-drawer-backdrop"
            (click)="closePanel($event)"
            aria-hidden="true"
        ></div>
        <div
            class="notification-panel"
            role="dialog"
            aria-labelledby="notification-panel-title"
            (click)="$event.stopPropagation()"
        >
            <div class="panel-header">
                <div class="panel-header-heading">
                    <h3 class="panel-title" id="notification-panel-title">
                        {{ 'header.notifications.title' | translate }}
                    </h3>
                    <button
                        type="button"
                        class="drawer-close"
                        (click)="closePanel($event)"
                        [attr.aria-label]="'header.notifications.closeDrawer' | translate"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="panel-toolbar">
                    <div class="segmented" role="tablist">
                        <button
                            type="button"
                            role="tab"
                            class="segment"
                            [class.active]="filterTab === 'all'"
                            [attr.aria-selected]="filterTab === 'all'"
                            (click)="setFilter('all', $event)"
                        >
                            {{ 'header.notifications.all' | translate }}
                        </button>
                        <button
                            type="button"
                            role="tab"
                            class="segment"
                            [class.active]="filterTab === 'unread'"
                            [attr.aria-selected]="filterTab === 'unread'"
                            (click)="setFilter('unread', $event)"
                        >
                            {{ 'header.notifications.unread' | translate }}
                        </button>
                    </div>
                    <button type="button" class="link-action mark-read" (click)="markAllRead($event)">
                        <span class="check" aria-hidden="true">✓</span>
                        {{ 'header.notifications.markAllRead' | translate }}
                    </button>
                </div>
            </div>

            <div class="panel-body">
                <div class="empty" *ngIf="visibleNotifications.length === 0 && !listPagination.loading">
                    {{ 'header.notifications.empty' | translate }}
                </div>
                <div class="loading-hint" *ngIf="visibleNotifications.length === 0 && listPagination.loading">
                    {{ 'header.notifications.loading' | translate }}
                </div>
                <ul class="notification-list" *ngIf="visibleNotifications.length > 0">
                    <li
                        *ngFor="let n of visibleNotifications"
                        class="notification-item"
                        [class.unread]="!n.read"
                        (click)="onItemClick(n, $event)"
                    >
                        <img class="avatar" [src]="n.avatarUrl || defaultAvatar" alt="" />
                        <div class="content">
                            <p class="message">
                                <ng-container *ngIf="n.title">
                                    <strong class="message-title" [class.unread-title]="!n.read">{{ n.title }}</strong>
                                    <!--
                                    <span class="message-sep" *ngIf="n.message">&nbsp;</span>
                                    -->
                                </ng-container>
                                <!-- <span class="message-body">{{ n.message }}</span> -->
                            </p>
                            <span class="time">{{ relativeTime(n.createdAt) }}</span>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="panel-footer">
                <div class="load-more-row">
                    <button
                        type="button"
                        class="load-more"
                        [disabled]="loadMoreDisabled"
                        (click)="loadMore($event)"
                    >
                        {{ 'header.notifications.loadMore' | translate }}
                        <span class="chevron" aria-hidden="true">▼</span>
                    </button>
                </div>
                <div class="footer-actions">
                    <button type="button" class="link-action clear-all" (click)="clearAll($event)">
                        {{ 'header.notifications.clearAll' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
